import { SIGN_OUT_CACHE_KEY } from '../const';
import { useSignOutMutation } from '../actions/signOut';

export const useSignOut = () => {
  const [handleSignOut, { isLoading: isSigningOut }] = useSignOutMutation({
    fixedCacheKey: SIGN_OUT_CACHE_KEY,
  });

  return { handleSignOut, isSigningOut };
};
